import { render, staticRenderFns } from "./epb-drag-and-drop.component.vue?vue&type=template&id=6abe9044&scoped=true"
import script from "./epb-drag-and-drop.component.vue?vue&type=script&lang=ts"
export * from "./epb-drag-and-drop.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-drag-and-drop.component.vue?vue&type=style&index=0&id=6abe9044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe9044",
  null
  
)

export default component.exports